import { SvgIcon } from "@mui/material";

// Eye Icon
export function RefreshIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
      }}
      width="24px"
      height="24px"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3851 21.251L8.60547 18.7738L11.0691 17.0039"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.32617 5.42167L6.35994 5.10156L6.67811 8.11782"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6746 7.24609L19.3971 10.0162L16.6426 8.74644"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0782 13.6719C18.9147 14.1905 18.688 14.7062 18.4068 15.2024C16.4521 18.6487 12.3315 20.079 8.73633 18.7723"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.61272 16.7262C5.24299 16.3273 4.90633 15.8749 4.61541 15.3855C2.58771 11.982 3.38361 7.69206 6.29867 5.21484"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79102 3.42125C10.3232 3.30741 10.8837 3.25 11.4538 3.25C15.4158 3.25 18.6929 6.12906 19.3302 9.90133"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
